module.exports = __webpack_public_path__ + "static/logo-6014ae87acea7146c7fbff687bc40145.png";